import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "common";
import { IState } from "store/store.interface";
import { KeyboardArrowDown } from "@material-ui/icons";
import MuiButton from "@material-ui/core/Button";
import PaymentOptions from "./PaymentOptions";
import { getPaymentMethods } from "store/actions/paymentMethods.actions";

interface IProps {
  label: string;
  name: string;
  getValue: (keys: string[]) => string | Date;
}

const PaymentMethods: FC<IProps> = ({ label, name, getValue }) => {
  const [isPaymentSelectionOpen, setIsPaymentSelectionOpen] =
    useState<boolean>(false);
  const dispatch = useDispatch();

  const { paymentMethods = [] } = useSelector((state: IState) => ({
    ...state.config,
    ...state.promotion,
    ...state.paymentMethods,
  }));

  const handlePaymentMethodClick = () => {
    setIsPaymentSelectionOpen(!isPaymentSelectionOpen);
  };

  useEffect(() => {
    dispatch(getPaymentMethods());
  }, []);

  return (
    <Box
      width="70%"
      mb={isPaymentSelectionOpen ? "450px" : 0}
      style={{ position: "relative" }}
    >
      <MuiButton
        color="primary"
        size="large"
        onClick={handlePaymentMethodClick}
        variant="outlined"
      >
        {label} <KeyboardArrowDown />
      </MuiButton>
      <PaymentOptions
        data-testid="payment-options"
        options={paymentMethods}
        isMenuOpen={isPaymentSelectionOpen}
        menuOpenHandler={setIsPaymentSelectionOpen}
        name={name}
        getValue={getValue}
      />
    </Box>
  );
};

export default PaymentMethods;
